export default "__VITE_ASSET__Dp9yab$X__"